import {
    MeshPhysicalMaterial,
    MeshStandardMaterial,
    type Material,
} from 'three'

const physicalDefaults = new MeshPhysicalMaterial()

/** Copy either PBR variant into the stable physical display material. */
export const copyVariantMaterial = (target:Material, source:Material):void => {
    if(
        target instanceof MeshPhysicalMaterial
        && source instanceof MeshStandardMaterial
        && !(source instanceof MeshPhysicalMaterial)
    ) {
        // Standard materials have no physical fields. Clear the preceding
        // variant's sheen/clearcoat/etc. before copying their common fields.
        target.copy(physicalDefaults)
        MeshStandardMaterial.prototype.copy.call(target, source)
        target.defines.PHYSICAL = ''
    } else {
        target.copy(source)
    }
}
